import { Action } from '@ngrx/store';
import { DirectorSearchFilter } from '../../models/directorSearchFilter';

export enum EDirectorListActions {
  SetSearchFilter = '[Director List] SET SEARCH FILTER',
  SetPagination = '[Director List] SET PAGINATION',
  SetSort = '[Director List] SET SORT',
  ClearFilters = '[Director List] CLEAR FILTERS'
}

export class SetSearchFilter implements Action {
  public readonly type = EDirectorListActions.SetSearchFilter;
  constructor(public payload: DirectorSearchFilter) {}
}

export class SetPagination implements Action {
  public readonly type = EDirectorListActions.SetPagination;
  constructor(public payload: { currentPage: number; pageSize: number }) {}
}

export class SetSort implements Action {
  public readonly type = EDirectorListActions.SetSort;
  constructor(public payload: { sortBy: string; ascending: boolean }) {}
}

export class ClearFilters implements Action {
  public readonly type = EDirectorListActions.ClearFilters;
}

export type DirectorListActions =
  | SetSearchFilter
  | SetPagination
  | SetSort
  | ClearFilters;
